export const roomsMainText = [
	{
		id: 0,
		category: 'rooms',
		name: 'Rooms Description',
		text: 'Coming soon!',
		textJ: 'Coming soon!',
		textCh1: 'Coming soon!',
		textCh2: 'Coming soon!',
	},
];